export class Rfs__funding{

    static sidebar_dyna(){};

    static Tab_ha(){};

    static reqGeneratePreview(){};

    //todo Page: Complete list
    static multiSel(){return null}

    //todo Page: Add Professor
    static searchFields(){return null}
    static useEffect_resetCountry(){return null}
    static useEffect_GetProfessor(){return null}



    //todo Subj: email card
    static btn_documents_intoEmail(){return null}
    static completeLst_btns_topEmails(){return null}
    static completeLst_btns_intoEmails(){return null}
    static preview_btns_topEmails(){return null}
    static preview_btns_intoEmails(){return null}
    static followUp_btns_topEmails(){return null}
    static followUp_btns_intoEmails(){return null}
    static professorCardV2_unknownBtn(){return null}



    //todo test
    static testGTM_GA(){}


    static joyRide(){}
}
